var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    transform: "translate(-259 -74)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(259 74)",
    fill: "#d84632"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    transform: "translate(271.747 86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    width: 18.507,
    height: 3.291,
    transform: "translate(1.547 15.379) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    width: 18.507,
    height: 3.291,
    transform: "translate(3.874 2.293) rotate(45)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.d80a61208ac531e3a671e4022e0db993.svg";
export { ForwardRef as ReactComponent };